import * as React from "react";

export const BaseItemExtensions: React.FunctionComponent<any> = () => {
    return (
        <div />
    );
};
